<template>
	<div class="pd">
		<div class="title-header">Логин</div>
		<div class="title-text">Введите логин и пароль</div>
	</div>
	<Form @submit="onSubmit">
		<CellGroup inset>
			<Field
				v-model="username"
				label="Логин"
				label-align="top"
				:rules="[
					{ required: true, message: 'Введите Логин' },
				]"
			/>
			<Field
				v-model="password"
				type="password"
				label="Пароль"
				label-align="top"
				:rules="[
					{ required: true, message: 'Укажите пароль' },
				]"
			/>
		</CellGroup>
		<div class="pd">
			<Button round block type="primary" loading loading-text="Входим" disabled v-if="isLoading" />
			<Button round block type="primary" native-type="submit" v-else>
				Войти
			</Button>
		</div>
	</Form>
</template>

<script>
import { ref } from 'vue';
import { Form, Field, CellGroup, Button, showToast } from 'vant';
import { isValidDate } from '@/components/common/utils';
import { useUserStore } from '@/stores/user';
import Api from '@/api/Api';
import { AppointmentStatuses } from '@/models/appointment';


export default {
	components: {
		Form, Field, CellGroup,
		Button,
	},
	setup() {
		const username = ref('');
		const password = ref('');
		const isLoading = ref(false);
		return {
			username,
			password,
			isLoading,
		};
	},
	methods: {
		onSubmit(values) {
			this.isLoading = true;
			Api.getToken2(
				this.username,
				this.password,
				error => {
					let errors = error.response.data.non_field_errors;
					if (errors) {
						showToast({
							message: errors[0],
							position: 'bottom',
						});
					}
				},
				this.$router,
			);
		},
	}
}
</script>
